import ImageDsMarketing from "../../../assets/preload/logo.png";
import IconLogoDsMktPlus from "../../../assets/header/DsMarketingPlus.png";
import { useStyles } from "../styles";
import axios from 'axios';
//import Button from "@mui/material/Button";
import { useNavigate } from "react-router-dom";
//import { MenuButton } from "../../../components/MenuButton";
//import MenuItem from "@mui/material/MenuItem";
import { useCallback, useState } from "react";
import { useAuth } from "../../../hooks/useAuth";
import { isLocalhost, isReleaseEnvironment } from "../../../utils/constants";
import { useToast } from "../../../hooks/useToast";
import { IconButtonMenu } from "../../../components/IconButtonMenu";
import IconLogoDsDsChat from "../../../assets/header/DsChat.png";
import IconLogoDeliverivip from "../../../assets/header/logoVenderMais.png";
import DropDown from "../../../assets/header/dropDown.png";



export type TabHeader = {
  label: string;
  value: Array<string>;
  children?: Array<TabHeader> | null;
  onClick?: () => void | null;
}

/* type Permission = {
  moduleId: number;
  moduleName: string;
  serviceId: number;
  serviceName: string;
}; */

export function LeftHeader() {
  const { token } = useAuth();
  const styles = useStyles();
  const navigate = useNavigate();
  //const location = useLocation();
  const toast = useToast();
  const [company] = useState(JSON.parse(localStorage.getItem("@datasales:user")!));
  //const [currentLocation,setCurrentLocation] = useState("");
  /* const tabsHeader: Array<TabHeader> = [
    {
      label: "Atrair",
      value: ["home"],
      children: null,
      onClick: () => handleNavigate("home")
    },
    {
      label: "Fidelizar",
      value: ["Base de Clientes","Campanhas","Descontos personalizados", "Ações Premiadas"],
      children: [
        {
          label: "Base de Clientes",
          value: ["Base de Clientes"],
          onClick: () => {
            hasPermitions('crm', 'ds.fidelize') ?
            window.location.replace(`https://crm-develop.datasales.info/sign-as-user/${token}`) :
            handleNavigate("withoutAccess")
          }
        },
        {
          label: "Campanhas SMS, Whatsapp e E-mail",
          value: ["Campanhas"],
          onClick: () => {
            hasPermitions('crm', 'ds.fidelize') ?
            window.location.replace(`https://crm-develop.datasales.info/sign-as-user/${token}?shortToRedirect=campaign`) :
            handleNavigate("withoutAccess")
          }
        },
        {
          label: "Descontos personalizados",
          value: ["Descontos personalizados"],
          onClick: () => {
            hasPermitions('crm', 'ds.fidelize') ?
            window.location.replace(`https://crm-develop.datasales.info/sign-as-user/${token}?shortToRedirect=offers`) :
            handleNavigate("withoutAccess")
          }
        },
        {
          label: "Ações Premiadas",
          value: ["Ações Premiadas"],
          onClick: () => {
            hasPermitions('crm', 'ds.fidelize') ?
            window.location.replace(`https://crm-develop.datasales.info/sign-as-user/${token}?shortToRedirect=campaign-awarded`) :
            handleNavigate("withoutAccess")
          },
        },
      ],
    },
    {
      label: "Analisar",
      value: ["Dashboard","Retorno sobre o Investimento","Campanhas de disparo em canais digitais", "Campanhas de descontos personalizados", "Visões personalizadas"],
      children: [
        {
          label: "Dashboard",
          value: ["dashboard"],
          onClick: () => handleNavigate("dashboard")
        },
        {
          label: "Campanhas de disparo em canais digitais",
          value: ["Campanhas de disparo em canais digitais"],
          onClick: () => {
            hasPermitions('crm', 'ds.fidelize') ?
            window.location.replace(`https://crm-develop.datasales.info/sign-as-user/${token}?shortToRedirect=results`) :
            handleNavigate("withoutAccess")
          }
        },
        {
          label: "Campanhas de descontos personalizados",
          value: ["Campanhas de descontos personalizados"],
          onClick: () => {
            hasPermitions('crm', 'ds.fidelize') ?
            window.location.replace(`https://crm-develop.datasales.info/sign-as-user/${token}?shortToRedirect=results-offers`) :
            handleNavigate("withoutAccess")
          }
        },
        {
          label: "Visões personalizadas",
          value: ["Visões personalizadas"],
          onClick: () => {
            hasPermitions('crm', 'ds.fidelize') ?
            window.location.replace(`https://crm-develop.datasales.info/sign-as-user/${token}?shortToRedirect=bi`) :
            handleNavigate("withoutAccess")
          }
        },
      ],
    },
    {
      label: "Vender",
      value: ["Delivery Vip"],
      onClick: () => {handleGoToDeliveryVip()}
    },
    {
      label: "Suporte",
      value: ["Vídeos passo a passo", "Agendar treinamento"],
      children: [
        {
          label: "Vídeos passo a passo",
          value: [' '],
          children: null,
          onClick: () => { window.open(
            'https://www.youtube.com/playlist?list=PLr7dYaCP_s-xDLMHwir93qh1USr9Mdfyx',
            '_blank'
          )}
        },
        {
          label: "Agendar treinamento",
          value: [' '],
          children: null,
          onClick: () => { window.open('https://calendly.com/datasales', '_blank') }
        }
      ]
    }, 
  ];*/

  const handleGoToDeliveryVip = useCallback(async () => {
    if (company.deliveryVip) {
      try {
        const loginVip = await axios.post(
          `https://api-backoffice.datasales.info/p2-dev/login/magicLink`,
          {
            memberId: company.deliveryVip.memberId,
            merchantId: company.deliveryVip.merchantId,
          }
        );
        window.open(`${loginVip.data.magic_link}`);
      } catch (e) {
        toast.show("Credencias inválidas", {
          severity: "warning",
        });
        window.location.replace(`https://tech.datasales.info/sign-as-user/${token}?shortToRedirect=form-delivery`)
      }
    } else {
      toast.show("Você não possui acesso a essa funcionalidade", {
        severity: "warning",
      });
      window.location.replace(`https://tech.datasales.info/sign-as-user/${token}?shortToRedirect=form-delivery`)
    }
  }, [company.deliveryVip, toast, token]);

  /*useEffect(()=>{
    setCurrentLocation(location.pathname.replace('/',''));
  },[location]);*/

  const handleGoToDsV3 = useCallback(
    (option: string) => {
      const alias = isLocalhost
        ? "https://tech.datasales.info"
        : isReleaseEnvironment ? "https://app.dsmarketing.com.br" : "https://app.dsmarketing.com.br";
      const urlDsV2 = ` ${alias}/sign-as-user/${token}?shortToRedirect=${option}`;
      window.location.assign(urlDsV2);
    },
    [token]
  );

  function handleNavigate(option: string) {
    switch (option) {
      case "dashboard":
        navigate(`/${option}`);
        break;
      case "withoutAccess":
        navigate(`/${option}`);
        break;
      case "whatsapp":
        isLocalhost || isReleaseEnvironment ? 
        navigate(`/${option}`) :
        handleGoToDsV3(option);
        break;  
      //case "account-settings":
        //navigate(`/${option}`);
        //break;
      default:
        //navigate(`/${option}`);
        handleGoToDsV3(option);
    }
  }

  /* function hasPermitions(module: string, permit: string) {
    const userPermissions = JSON.parse(localStorage.getItem('@datasales:permissions') || '{}');
    let permission = userPermissions[module]?.find((permission: Permission) => permission.serviceName.includes(permit))
    if(!permission) {
      permission = userPermissions?.find((permission: any) => permission.service.name.includes(permit))
    }
    return Boolean(permission);
  } */

  const handleGoToDsMktPlus = useCallback(() => {
    const urlDsCrm = `https://plus.datasales.info/sign-as-user/${token}`;
    window.open(urlDsCrm);
  }, [token]);

  return (
    <div id="header-block-left" className={styles.rootLeft}
     style={{marginLeft: '24px'}}>
      <IconButtonMenu
        color="default"
        aria-label="apps"
        size="small"
        options={[
          {
            icon: IconLogoDsMktPlus,
            label: "Fidelizar",
            onClick: handleGoToDsMktPlus,
          },
          {
            icon: IconLogoDsDsChat,
            label: "DS Omni",
            onClick: () => handleNavigate("chat"),
          },
          {
            icon: IconLogoDeliverivip,
            label: "Vender mais",
            onClick: () => handleGoToDeliveryVip(),
          },
        ]}
      >
      <img
        id="logo-ds-marketing"
        className={styles.image}
        src={ImageDsMarketing}
        alt="ds-marketing"
      />
      <img src={DropDown} alt="dropDown" />
      </IconButtonMenu> 
        {/*tabsHeader.map((tab) => {
          if(tab.children?.length){
            return (
              <MenuButton
                key={tab.value[0]}
                id="btn-apps"
                sx={{
                  ...(tab.value.includes(currentLocation) && {
                    color: '#0C20B5 !important',
                    borderBottom: "solid 2px #0C20B5"
                  })
                }}
                className={styles.btnOptions}
                variant="text"
                label={tab.label}
              >
                {tab.children.map((son)=>(

                  <MenuItem
                    key={son.value[0]}
                    onClick={son.onClick}
                    sx={{
                      ...(currentLocation.includes(son.value[0]) && {
                        color: '#0C20B5 !important',
                        borderBottom: "solid 2px #0C20B5"
                      })
                    }}
                    className={styles.btnOptions}
                >
                  {son.label}
                </MenuItem>
                ))}
              </MenuButton>
            )
          }else{  
            return (
            <Button
              key={tab.value[0]}
              id="btn-init"
              onClick={tab.onClick}
              sx={{
                  ...(currentLocation.includes(tab.value[0]) && {
                    color: '#0C20B5 !important', 
                    borderBottom: "solid 2px blue",
                  })
                }}
              className={styles.btnOptions}
              variant="text"
            >
              {tab.label}
            </Button>)
          }
        
        })*/}
    </div>
  );
}
